export const TRACE_ID_NAME = 'x-housing-trace-id';
export const MIN_LOAN_AMOUNT = 100_000;

